// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { renderer } from '../helpers/renderer';
const Spinner = () => {
    return (renderer.create("div", { class: "spinner" },
        renderer.create("div", { class: "spinner--bounce spinner--bounce1" }),
        renderer.create("div", { class: "spinner--bounce spinner--bounce2" }),
        renderer.create("div", { class: "spinner--bounce spinner--bounce3" })));
};
export default Spinner;
